module.exports = __webpack_public_path__ + "img/PDFIcon.f052de0b.svg";